const t = {
  "card--content": "_card--content_s32sm_1"
};
export {
  t as default
};
//# sourceMappingURL=index.es5470.js.map
